import { render } from "./develop.vue?vue&type=template&id=95b18710&scoped=true"
import script from "./develop.vue?vue&type=script&lang=js"
export * from "./develop.vue?vue&type=script&lang=js"

import "./develop.vue?vue&type=style&index=0&id=95b18710&scoped=true&lang=css"
import "./develop.vue?vue&type=style&index=1&id=95b18710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b18710"]])

export default __exports__